import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export class CheckoutInit extends Vue {
    @Prop({ type: Number }) orderId!: number

    // we ovverride this in the single components
    // tslint:disable-next-line:no-empty
    initSession() {}

    onSuccess() {
        // TODO: https://github.com/fluttercommunity/flutter_webview_plugin/issues/337 once issue fixed, revert back to router.push
        // Vue.router.push({ name: 'CheckoutSuccess', params: { orderId: this.orderId } })
        window.location.href =
            process.env.NODE_ENV === 'production'
                ? `https://beatpulse.app/checkout/success/${this.orderId}`
                : `https://test.beatpulse.app/checkout/success/${this.orderId}`
    }

    onError() {
        // TODO: https://github.com/fluttercommunity/flutter_webview_plugin/issues/337 once issue fixed, revert back to router.push
        // Vue.router.push({ name: 'CheckoutCancel' })
        window.location.href = process.env.NODE_ENV === 'production' ? `https://beatpulse.app/checkout/cancel` : `https://test.beatpulse.app/checkout/cancel`

    }

    beforeMount() {
        document.body.style.backgroundColor = 'white'
    }

    mounted() {
        // @ts-ignore
        window.$crisp.push(['do', 'chat:hide'])
    }

    beforeDestory() {
        // @ts-ignore
        window.$crisp.push(['do', 'chat:show'])
    }

    created() {
        this.initSession()
    }
}
